<template>
  <validation-observer class="message" ref="observer" tag="div" v-slot="{handleSubmit, invalid}">
    <div class="inner">
      <form @submit.prevent="handleSubmit(sendDm)">
        <validation-provider rules="required" name="メッセージ">
          <textarea @keyup.enter.ctrl="sendDm" name="direct_message" v-model="message" placeholder="メッセージを入力" />
        </validation-provider>
        <input type="submit" class="btn" :disabled="invalid" value="送信" />
      </form>
    </div>
  </validation-observer>
</template>

<script>
export default {
  name: "MessageForm",
  data() {
    return {
      message: null
    }
  },
  methods: {
    sendDm: async function() {
      const isValid = await this.$refs.observer.validate()

      if (!isValid) return

      this.$emit("dispatch-dm", this.message)
      this.message = null
    }
  }
}
</script>

<style scoped>
  .message {
    width: 100%;
  }
</style>
